<form id="contact-form" [formGroup]="contactFormGroup">
    <div class="row">
        <div class="col-12">
            <div class="form-group">
                <input type="text" class="form-control" name="name" placeholder="This is User Name" required="required" [formControl]="nameControl">
            </div>
            <div class="form-group">
                <input type="text" class="form-control" name="company" placeholder="Company Name" required="required" [formControl]="companyControl">
            </div>
            <div class="form-group">
                <input type="email" class="form-control" name="email" placeholder="Email" required="required" [formControl]="emailControl">
            </div>
            <div class="form-group">
                <input type="text" class="form-control" name="phone" placeholder="Phone" required="required" [formControl]="phoneControl">
            </div>
        </div>
        <div class="col-12">
            <div class="form-group">
                <textarea class="form-control" name="message" placeholder="Message" required="required" [formControl]="messageControl"></textarea>
            </div>
        </div>
        <div class="col-12">
            <button type="button" class="btn btn-bordered active btn-block mt-3" (click)="sendEmail()" [disabled]="status === 'submitting'"><span class="text-white pr-3"><i class="fas fa-paper-plane"></i></span>Send Message</button>
            <p *ngIf="status === 'success'" class="mt-3">Thanks! Your message has been sent — we'll be in touch soon.</p>
            <p *ngIf="status === 'error'" class="mt-3" style="color: #b00020;">Sorry, something went wrong sending your message. Please email info&#64;avantamarketing.com directly.</p>
        </div>
    </div>
</form>